import { ListViewItem } from "@repo/skapa";
import { type ReactElement, type SVGProps } from "react";

interface Props<K> {
  label: string | ReactElement;
  id: K;
  value: string;
  onCheckFilter: (filter: K, checked: boolean) => any;
  checked?: boolean;
  icon?: (prefix?: string) => SVGProps<SVGElement>[];
}

export const FilterCheckbox = <K,>({
  label,
  id,
  value,
  onCheckFilter,
  checked,
  icon,
}: Props<K>) => {
  const click = () => {
    onCheckFilter(id, !checked);
  };

  return (
    <ListViewItem
      id={`${String(id)}-${value}`}
      title={label}
      control="checkbox"
      controlProps={{
        value: value,
        checked: checked,
        onChange: click,
      }}
      leadingIcon={icon}
      showDivider={false}
      emphasised={false}
    />
  );
};
